import { ListProvider } from "./list-provider";
import { MembershipStoreFacade } from "../../../../business-objects/membership/membership.store-facade";
import { Membership } from "../../../../business-objects/membership/membership.model";
import { User } from "../../../../business-objects/user/user.model";

export class MembershipListProvider extends ListProvider<Membership> {

    getFacade(): MembershipStoreFacade {
        return this.appFacade.objects.membership.store;
    }

    getPrimaryField(item: Membership): string {
        return this.getUserByMembershipId(item.user).name;
    }

    getSecondaryField(item: Membership): string {
        return this.getUserByMembershipId(item.user).email;
    }

    protected getUserByMembershipId(id: string): User {
        let user: User;
        this.appFacade.objects.user.store
            .get(id)
            .take(1)
            .subscribe(u => user = u);
        return user || new User();
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/list-picker/form/list-providers/membership-list-provider.ts